module.exports = __webpack_public_path__ + "static/media/6.f1240db7.mp3";